/**
 * Socket Events Constants
 */

export const SOCKET_EVENTS = {
  AUTH: "auth",
  MESSAGE_NEW: "message:new",
  MESSAGE_UPDATE: "message:update",
  MESSAGE_DELETE: "message:delete",
  MESSAGE_READ: "message:read",
  TYPING: "typing",
  PRESENCE: "presence",
  CONVERSATION_UPDATE: "conversation:update",
  CONVERSATION_NEW: "conversation:new",
  CONVERSATION_STATE_CHANGED: "conversation:state_changed",
} as const;

export type SocketEventName =
  (typeof SOCKET_EVENTS)[keyof typeof SOCKET_EVENTS];

